(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[289],{

/***/ 21181:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/donors",
      function () {
        return __webpack_require__(99915);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 32234:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/charles-schwab-logo.cb74bef1.svg","height":27,"width":186});

/***/ }),

/***/ 27754:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/fidelity-logo.3fc5a7d3.svg","height":33,"width":137});

/***/ }),

/***/ 51374:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/bestFriendsDT.7c939296.png","height":1918,"width":3456,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAD1BMVEX+/v75+vzz8/fq6+/56t3vBoQkAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAI0lEQVQImR2KsREAMBCCEH//mXOxoQBIgIwoEbiLM639AXc8A5kAKknxPj0AAAAASUVORK5CYII="});

/***/ }),

/***/ 54869:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/orgSearchDT.6ec9799d.png","height":1986,"width":3458,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAFVBMVEXz9fn9/f36+/zn5u/v7fDh4OTn8/nMo+v1AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAI0lEQVQImRXGyREAMAwDodWV/kv2hBck28ID2mKQjW39B9ABBdIAP0Zdcb4AAAAASUVORK5CYII="});

/***/ }),

/***/ 53736:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/reproRightsDT.d6d01d8c.png","height":1888,"width":3454,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAADFBMVEX////y8PD29fP85t1AzSsVAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAGklEQVQImWNgYGBiZGIAA0ZGJmYoAyoEYQAAAbUAF/u24ykAAAAASUVORK5CYII="});

/***/ }),

/***/ 64742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ FeeComparison; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97700);
/* harmony import */ var _endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(49423);
/* harmony import */ var _endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56050);
/* harmony import */ var _endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93636);
/* harmony import */ var _images_logos_charles_schwab_logo_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32234);
/* harmony import */ var _images_logos_fidelity_logo_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27754);
/* harmony import */ var _cardTable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57216);
/* harmony import */ var _sectionLabel__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12219);
/* harmony import */ var _FeeComparison_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89320);
/* harmony import */ var _FeeComparison_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_FeeComparison_module_scss__WEBPACK_IMPORTED_MODULE_4__);









var FeeComparison = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (_FeeComparison_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["fee-section"]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_5__/* .Card */ .Z, {
                className: (_FeeComparison_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["fee-comparison"]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sectionLabel__WEBPACK_IMPORTED_MODULE_6__/* .SectionLabel */ .e, {
                        text: "Fee Comparison",
                        smaller: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable */ .c, {
                        headers: [
                            "Service",
                            "Donation Fee",
                            "Granting Fee",
                            "Total Fee"
                        ],
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Row */ .c.Row, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_FeeComparison_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["logo-cell"]),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_8__/* .LogoIcon */ .K, {
                                                    color: "currentColor"
                                                }),
                                                "for Donors"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        center: true,
                                        children: "0.5%"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        center: true,
                                        children: "1.0%"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        center: true,
                                        children: "1.5%"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Row */ .c.Row, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                    header: true,
                                    colSpan: 4,
                                    className: (_FeeComparison_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["full-row-col"]),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {})
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Row */ .c.Row, {
                                className: (_FeeComparison_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["fake-second-header"]),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        header: true,
                                        children: "\xa0"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        header: true,
                                        children: "Admin Fee"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        header: true,
                                        children: "Investment Fee"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        header: true,
                                        children: "Total Fee*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Row */ .c.Row, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            src: _images_logos_charles_schwab_logo_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
                                            alt: "Charles Schwab",
                                            width: 190,
                                            height: 25
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        center: true,
                                        children: "1.2%"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        center: true,
                                        children: "1.6%"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        center: true,
                                        children: "2.8%"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Row */ .c.Row, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            src: _images_logos_fidelity_logo_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
                                            alt: "Fidelity",
                                            width: 140,
                                            height: 33
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        center: true,
                                        children: "1.2%"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        center: true,
                                        children: "1.2%"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        center: true,
                                        children: "2.4%"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .z, {
                        as: "a",
                        size: "small",
                        href: "https://docs.endaoment.org/donors/fee-schedule",
                        target: "_blank",
                        rel: "noreferrer",
                        children: [
                            "Read more about fees",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_10__/* .ArrowIcon */ .e, {
                                width: 20
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_FeeComparison_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["fee-footnote"]),
                children: "*Based on 4.5yr average granting schedule"
            })
        ]
    });
};


/***/ }),

/***/ 57216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ CardTable; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6277);
/* harmony import */ var _CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16962);
/* harmony import */ var _CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5__);






var Column = function(_param) {
    var _header = _param.header, header = _header === void 0 ? false : _header, _center = _param.center, center = _center === void 0 ? false : _center, children = _param.children, className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "header",
        "center",
        "children",
        "className"
    ]);
    var Element = header ? "th" : "td";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Element, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(header ? (_CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["card-table-header"]) : (_CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["card-table-column"]), center && (_CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5___default().center), className)
    }, props), {
        children: children
    }));
};
var Row = function(_param) {
    var _bold = _param.bold, bold = _bold === void 0 ? false : _bold, _center = _param.center, center = _center === void 0 ? false : _center, children = _param.children, className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "bold",
        "center",
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tr", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((_CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["card-table-row"]), bold && (_CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5___default().bold), center && (_CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5___default().center), className)
    }, props), {
        children: children
    }));
};
var CardTable = function(_param) {
    var headers = _param.headers, children = _param.children, className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "headers",
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("table", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((_CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["card-table"]), className)
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Row, {
                    children: headers.map(function(val, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Column, {
                            header: true,
                            children: val !== "" ? val : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: "\xa0"
                            })
                        }, i + val);
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tbody", {
                children: children
            })
        ]
    }));
};

CardTable.Row = Row;
CardTable.Col = Column;


/***/ }),

/***/ 63993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ DoubleFeature; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1401);
/* harmony import */ var _DoubleFeature_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85849);
/* harmony import */ var _DoubleFeature_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_DoubleFeature_module_scss__WEBPACK_IMPORTED_MODULE_1__);



var DoubleFeature = function(param) {
    var pillLeft = param.pillLeft, pillRight = param.pillRight, headerLeft = param.headerLeft, headerRight = param.headerRight, extraLeft = param.extraLeft, extraRight = param.extraRight;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (_DoubleFeature_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["double-feature"]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_2__/* .Pill */ .D, {
                        size: "large",
                        variation: "orange",
                        children: pillLeft
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        children: headerLeft
                    }),
                    extraLeft && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: extraLeft
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_2__/* .Pill */ .D, {
                        size: "large",
                        variation: "blue",
                        children: pillRight
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        children: headerRight
                    }),
                    extraRight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: extraRight
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 32985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ ImageButtonRow; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6277);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../libs/ui/shared/src/lib/button/Button.tsx + 1 modules
var Button = __webpack_require__(93636);
// EXTERNAL MODULE: ./content/imageButtonRow/ImageButtonRow.module.scss
var ImageButtonRow_module = __webpack_require__(28405);
var ImageButtonRow_module_default = /*#__PURE__*/__webpack_require__.n(ImageButtonRow_module);
;// CONCATENATED MODULE: ./content/imageButtonRow/ImageButton.tsx







var ImageButton = function(_param) {
    var label = _param.label, href = _param.href, paragraph = _param.paragraph, icon = _param.icon, className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "label",
        "href",
        "paragraph",
        "icon",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        as: "a",
        href: href,
        target: "_blank",
        rel: "noreferrer",
        cardIcon: icon,
        className: (0,clsx_m/* default */.Z)(className, (ImageButtonRow_module_default())["image-button"])
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    children: label
                }),
                paragraph && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: paragraph
                })
            ]
        })
    }));
};


;// CONCATENATED MODULE: ./content/imageButtonRow/ImageButtonRow.tsx




var ImageButtonRow = function(param) {
    var title = param.title, children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,clsx_m/* default */.Z)((ImageButtonRow_module_default())["image-button-row"], className),
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: children
            })
        ]
    });
};
ImageButtonRow.Button = ImageButton;


/***/ }),

/***/ 19002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ MediaCarousel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6277);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6917);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76453);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50589);
/* harmony import */ var _endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56050);
/* harmony import */ var _editable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85968);
/* harmony import */ var _sectionLabel__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12219);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84988);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68522);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _MediaCarousel_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73314);
/* harmony import */ var _MediaCarousel_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_MediaCarousel_module_scss__WEBPACK_IMPORTED_MODULE_7__);












var MediaCard = function(param) {
    var source = param.source, title = param.title, snippet = param.snippet, date = param.date, href = param.href;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: href,
        target: "_blank",
        rel: "noreferrer",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_6__/* .Card */ .Z, {
            className: (_MediaCarousel_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["media-card"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((_MediaCarousel_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["media-source"]), typeof source === "string" && (_MediaCarousel_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["source-text"])),
                    children: source
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_MediaCarousel_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["media-title"]),
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: snippet
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_MediaCarousel_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["media-date"]),
                    children: date
                })
            ]
        })
    });
};
var MediaCarousel = function() {
    var isMobile = (0,react_use__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)("(max-width: 55rem)", true);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (_MediaCarousel_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["media-carousel"]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sectionLabel__WEBPACK_IMPORTED_MODULE_10__/* .SectionLabel */ .e, {
                center: true,
                text: "Media"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .tq, {
                direction: "horizontal",
                slidesPerView: isMobile ? 1 : 3,
                spaceBetween: 25,
                loop: true,
                modules: isMobile ? [
                    swiper__WEBPACK_IMPORTED_MODULE_1__/* .Autoplay */ .pt,
                    swiper__WEBPACK_IMPORTED_MODULE_1__/* .Pagination */ .tl
                ] : [
                    swiper__WEBPACK_IMPORTED_MODULE_1__/* .Autoplay */ .pt
                ],
                pagination: isMobile,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                },
                speed: 1000,
                children: _editable__WEBPACK_IMPORTED_MODULE_3__/* .MEDIA_SLIDES.map */ .Qd.map(function(props, i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .SwiperSlide */ .o5, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MediaCard, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, props))
                    }, i + props.title);
                })
            })
        ]
    });
};


/***/ }),

/***/ 57640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ NDAOTokenCallout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17982);
/* harmony import */ var _endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56963);
/* harmony import */ var _endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49423);
/* harmony import */ var _endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93636);
/* harmony import */ var _NDAOTokenCallout_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66404);
/* harmony import */ var _NDAOTokenCallout_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_NDAOTokenCallout_module_scss__WEBPACK_IMPORTED_MODULE_1__);




var NDAOTokenCallout = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (_NDAOTokenCallout_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["callout-container"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_NDAOTokenCallout_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["callout-inner"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_NDAOTokenCallout_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["ndao-callout"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_2__/* .NDAOTokenIcon */ .k, {})
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_3__/* .NVTTokenIcon */ .Y, {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                    children: "NDAO"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                            children: "Community Driven Impact"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, {
                    as: "a",
                    className: (_NDAOTokenCallout_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["learn-more-button"]),
                    href: "/ndao",
                    children: [
                        "Learn More",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_5__/* .ArrowIcon */ .e, {
                            width: 19.5,
                            height: 11.5
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 22980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ TwoScreensSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49423);
/* harmony import */ var _endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93636);
/* harmony import */ var _sectionLabel__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(12219);
/* harmony import */ var _TwoScreensSection_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78091);
/* harmony import */ var _TwoScreensSection_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_TwoScreensSection_module_scss__WEBPACK_IMPORTED_MODULE_8__);










var TwoScreensButton = function(_param) {
    var text = _param.text, href = _param.href, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "href"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            as: "a",
            target: "_blank",
            rel: "noreferrer"
        }, props), {
            children: [
                text,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_7__/* .ArrowIcon */ .e, {
                    width: 20,
                    height: 12
                })
            ]
        }))
    });
};
var TwoScreensSection = function(param) {
    var title = param.title, image1Src = param.image1Src, image2Src = param.image2Src, subtext = param.subtext, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (_TwoScreensSection_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["two-screens-section"]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sectionLabel__WEBPACK_IMPORTED_MODULE_9__/* .SectionLabel */ .e, {
                text: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_TwoScreensSection_module_scss__WEBPACK_IMPORTED_MODULE_8___default().screenshot),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            src: image1Src,
                            alt: "Product screenshot",
                            priority: true,
                            layout: "fill",
                            placeholder: "blur"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_TwoScreensSection_module_scss__WEBPACK_IMPORTED_MODULE_8___default().screenshot),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            src: image2Src,
                            alt: "Product screenshot",
                            priority: true,
                            layout: "fill",
                            placeholder: "blur"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: subtext
            }),
            children
        ]
    });
};
TwoScreensSection.Button = TwoScreensButton;


/***/ }),

/***/ 99915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ donors; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../libs/config/src/lib/config.ts
var config = __webpack_require__(46518);
// EXTERNAL MODULE: ../../libs/ui/icons/src/lib/StarIcon.tsx
var StarIcon = __webpack_require__(9357);
// EXTERNAL MODULE: ../../libs/ui/shared/src/lib/pill/Pill.tsx
var Pill = __webpack_require__(1401);
// EXTERNAL MODULE: ../../libs/ui/shared/src/lib/button/Button.tsx + 1 modules
var Button = __webpack_require__(93636);
// EXTERNAL MODULE: ./content/advisors/feeComparison/FeeComparison.tsx
var FeeComparison = __webpack_require__(64742);
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useMedia.js
var useMedia = __webpack_require__(6917);
// EXTERNAL MODULE: ../../node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(76453);
// EXTERNAL MODULE: ../../node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(50589);
// EXTERNAL MODULE: ../../libs/ui/shared/src/lib/card/Card.tsx
var Card = __webpack_require__(56050);
// EXTERNAL MODULE: ../../libs/utils/src/lib/formatters.ts
var formatters = __webpack_require__(97022);
// EXTERNAL MODULE: ./editable.tsx + 22 modules
var editable = __webpack_require__(85968);
// EXTERNAL MODULE: ./content/sectionLabel/SectionLabel.tsx
var SectionLabel = __webpack_require__(12219);
// EXTERNAL MODULE: ../../node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(84988);
// EXTERNAL MODULE: ./content/donors/portfolioAllocations/PortfolioAllocations.module.scss
var PortfolioAllocations_module = __webpack_require__(50134);
var PortfolioAllocations_module_default = /*#__PURE__*/__webpack_require__.n(PortfolioAllocations_module);
;// CONCATENATED MODULE: ./content/donors/portfolioAllocations/PortfolioAllocations.tsx










var PortfolioAllocations = function() {
    var isMobile = (0,useMedia/* default */.Z)("(max-width: 71rem)", true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (PortfolioAllocations_module_default())["portfolio-allocations"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionLabel/* SectionLabel */.e, {
                text: "Crypto-Native Portfolio Allocations",
                center: true,
                className: (PortfolioAllocations_module_default()).title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (PortfolioAllocations_module_default()).subtitle,
                children: "Deploy donations directly to crypto assets & DeFi yield to grow your impact."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                direction: "horizontal",
                slidesPerView: isMobile ? 1 : 2,
                spaceBetween: 40,
                loop: true,
                modules: [
                    swiper_esm/* Autoplay */.pt
                ],
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                },
                children: editable/* PORTFOLIO_ALLOCATION_SLIDES.map */.Ut.map(function(props, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* Card */.Z, {
                            className: (PortfolioAllocations_module_default()).card,
                            children: [
                                props.logo,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    children: props.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: props.type
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (PortfolioAllocations_module_default()).description,
                                    children: props.description
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (PortfolioAllocations_module_default())["deposit-cap"],
                                    children: props.depositCap ? "Deposit Cap: ".concat((0,formatters/* getFormattedMoney */.Sy)(props.depositCap)) : "No Deposit Cap"
                                })
                            ]
                        })
                    }, i + props.name);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (PortfolioAllocations_module_default())["footer-text"],
                children: "This fall, we'll be bringing native crypto investing and wealth management into our contracts and web apps."
            })
        ]
    });
};

// EXTERNAL MODULE: ./content/doubleFeature/DoubleFeature.tsx
var DoubleFeature = __webpack_require__(63993);
// EXTERNAL MODULE: ./content/imageButtonRow/ImageButtonRow.tsx + 1 modules
var ImageButtonRow = __webpack_require__(32985);
// EXTERNAL MODULE: ./content/mediaCarousel/MediaCarousel.tsx
var MediaCarousel = __webpack_require__(19002);
// EXTERNAL MODULE: ./content/metaTags/MetaTags.tsx
var MetaTags = __webpack_require__(19055);
// EXTERNAL MODULE: ./content/ndaoTokenCallout/NDAOTokenCallout.tsx
var NDAOTokenCallout = __webpack_require__(57640);
// EXTERNAL MODULE: ./content/socialLinks/SocialLinks.tsx + 4 modules
var SocialLinks = __webpack_require__(37321);
// EXTERNAL MODULE: ./content/textGridWithLogo/TextGridWithLogo.tsx
var TextGridWithLogo = __webpack_require__(45792);
// EXTERNAL MODULE: ./content/twoScreensSection/TwoScreensSection.tsx
var TwoScreensSection = __webpack_require__(22980);
// EXTERNAL MODULE: ./images/screenshots/bestFriendsDT.png
var bestFriendsDT = __webpack_require__(51374);
// EXTERNAL MODULE: ./images/screenshots/myFundsDT.png
var myFundsDT = __webpack_require__(53424);
;// CONCATENATED MODULE: ./images/screenshots/orgCardsDT.png
/* harmony default export */ var orgCardsDT = ({"src":"/_next/static/media/orgCardsDT.c0fe3005.png","height":1986,"width":3454,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAADFBMVEX2+Pr9/v7z9PXt7O0Bbp9DAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAH0lEQVQImT3GsQ0AMBCEMOD23/mLSHFlDAgxYj8T93ICggApc73KcAAAAABJRU5ErkJggg=="});
// EXTERNAL MODULE: ./images/screenshots/orgSearchDT.png
var orgSearchDT = __webpack_require__(54869);
// EXTERNAL MODULE: ./images/screenshots/reproRightsDT.png
var reproRightsDT = __webpack_require__(53736);
// EXTERNAL MODULE: ./smart/index.ts + 2 modules
var smart = __webpack_require__(54634);
// EXTERNAL MODULE: ./styles/donors.module.scss
var donors_module = __webpack_require__(49158);
var donors_module_default = /*#__PURE__*/__webpack_require__.n(donors_module);
;// CONCATENATED MODULE: ./pages/donors.tsx











// import { NDAOTokenCallout } from '../content/ndaoTokenCallout';











var DonorsPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* MetaTags */.N, {
                url: "/donors",
                title: "Endaoment | Donors"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (donors_module_default())["donor-hero"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill/* Pill */.D, {
                        size: "large",
                        variation: "blue",
                        children: "For Individual Donors"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (donors_module_default())["donor-screenshot"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: myFundsDT/* default */.Z,
                            priority: true,
                            layout: "fill",
                            alt: "Product screenshot",
                            placeholder: "blur"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (donors_module_default())["donor-cta"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: "The first on-chain donor-advised fund. Just a transaction away. "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                as: "a",
                                href: "".concat(config/* config.clientBaseUrl */.v.clientBaseUrl, "/orgs"),
                                target: "_blank",
                                rel: "noreferrer",
                                className: (donors_module_default())["cta-button"],
                                cardIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(StarIcon/* StarIcon */.r, {}),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            children: "Start a Fund"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Give now, get a receipt and grant over time."
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (donors_module_default())["stats-container"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(smart/* SMStatsCard */.N, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoScreensSection/* TwoScreensSection */.U, {
                title: "On-Chain Donation Interface",
                image1Src: reproRightsDT/* default */.Z,
                image2Src: orgSearchDT/* default */.Z,
                subtext: "We've built a crypto-native giving exerience from the ground up that works just like our favorite DeFi and crypto applications.",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoScreensSection/* TwoScreensSection.Button */.U.Button, {
                    text: "Launch App",
                    href: config/* config.clientBaseUrl */.v.clientBaseUrl
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PortfolioAllocations, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoScreensSection/* TwoScreensSection */.U, {
                title: "Easy Donations to 1.5 Million Organizations",
                image1Src: orgCardsDT,
                image2Src: bestFriendsDT/* default */.Z,
                subtext: "We've paired with Candid's GuideStar nonprofit database to surface the best nonprofits in the U.S.",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoScreensSection/* TwoScreensSection.Button */.U.Button, {
                    text: "Launch App",
                    href: config/* config.clientBaseUrl */.v.clientBaseUrl
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageButtonRow/* ImageButtonRow */.p, {
                title: "Learn More",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageButtonRow/* ImageButtonRow.Button */.p.Button, {
                        label: "Request a Demo",
                        paragraph: "Learn more about how the app works",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(StarIcon/* StarIcon */.r, {}),
                        href: "https://endaoment.typeform.com/request-demo"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageButtonRow/* ImageButtonRow.Button */.p.Button, {
                        label: "Read our FAQ",
                        paragraph: "Find answers to your Endaoment questions",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(StarIcon/* StarIcon */.r, {}),
                        href: "/learn#faq-section"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageButtonRow/* ImageButtonRow.Button */.p.Button, {
                        label: "Contact Us",
                        paragraph: "Contact an Endaoment representative",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(StarIcon/* StarIcon */.r, {}),
                        href: "mailto:partnerships@endaoment.org"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DoubleFeature/* DoubleFeature */.W, {
                pillLeft: "In-App Donations",
                pillRight: "OTC Donations",
                headerLeft: "Donate over 1,000+ different kinds of digital assets in-app",
                headerRight: "Donate from any blockchain over-the-counter",
                extraLeft: "Industry-low 1.5% fee",
                extraRight: "Yes, even NFTs"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextGridWithLogo/* TextGridWithLogo */.X, {
                headerText: "Self-directed, crypto-native, flexible giving without compromising on compliance.",
                pillText: "Built for Crypto Investors",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextGridWithLogo/* TextGridWithLogo.Item */.X.Item, {
                        header: "Donor-Advised Funds",
                        text: "Donate any asset at any time and get a tax receipt immediately. Come back later and make grant recommendations to more than 1.5 million nonprofits whenever inspiration strikes.",
                        buttonText: "Open a Fund",
                        href: "".concat(config/* config.clientBaseUrl */.v.clientBaseUrl, "/funds/create")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextGridWithLogo/* TextGridWithLogo.Item */.X.Item, {
                        header: "Direct Donations",
                        text: "Know where you want to give? Head straight to the profile of your favorite nonprofit and easily donate any crypto asset directly to the organization.",
                        buttonText: "Find an Org",
                        href: "".concat(config/* config.clientBaseUrl */.v.clientBaseUrl, "/orgs")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextGridWithLogo/* TextGridWithLogo.Item */.X.Item, {
                        header: "Community Funds",
                        text: "Not sure where to give? Community Funds leverage our incredible community's knowledge base to direct donations around specific issue areas and causes.",
                        buttonText: "Browse Community Funds",
                        href: "".concat(config/* config.clientBaseUrl */.v.clientBaseUrl, "/funds/community")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextGridWithLogo/* TextGridWithLogo.Item */.X.Item, {
                        header: "Endorsements",
                        text: "Soon you can help us curate the best and most effective nonprofits by endorsing them. Earn rewards for contributing your perspective while driving excess fee revenue to organizations you endorse.",
                        comingSoon: true,
                        // TODO: Figure out where this goes
                        href: "#"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextGridWithLogo/* TextGridWithLogo.Item */.X.Item, {
                        header: "Portfolio Allocations",
                        text: "Don't let your philanthropic capital sit idly by while you find the perfect organization to support. Easily deploy dollars in your Endaoment Fund into DeFi yield bearing and crypto investment options.",
                        comingSoon: true,
                        // TODO: Figure out where this goes
                        href: "#"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeeComparison/* FeeComparison */.l, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NDAOTokenCallout/* NDAOTokenCallout */.d, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaCarousel/* MediaCarousel */.Q, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialLinks/* SocialLinks */.W, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var donors = (DonorsPage);


/***/ }),

/***/ 17982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ NDAOTokenIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);




var NDAOTokenIcon = function(_param) {
    var _width = _param.width, width = _width === void 0 ? 86 : _width, height = _param.height, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "width",
        "height"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: width,
        height: height !== null && height !== void 0 ? height : width,
        viewBox: "0 0 86 86",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "43",
                cy: "43",
                r: "41.5",
                fill: "#627EEA",
                stroke: "#1F49EA",
                strokeWidth: "3"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M26.5591 30.8527C29.2458 30.8527 31.4237 28.6747 31.4237 25.9879C31.4237 23.3018 29.2458 21.1238 26.5591 21.1238C23.8732 21.1238 21.6953 23.3018 21.6953 25.9879C21.6953 28.6747 23.8732 30.8527 26.5591 30.8527Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M26.5591 63.936C29.2458 63.936 31.4237 61.758 31.4237 59.0719C31.4237 56.385 29.2458 54.207 26.5591 54.207C23.8732 54.207 21.6953 56.385 21.6953 59.0719C21.6953 61.758 23.8732 63.936 26.5591 63.936Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M59.2796 30.8527C61.9656 30.8527 64.1434 28.6747 64.1434 25.9879C64.1434 23.3018 61.9656 21.1238 59.2796 21.1238C56.5929 21.1238 54.415 23.3018 54.415 25.9879C54.415 28.6747 56.5929 30.8527 59.2796 30.8527Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M59.2796 63.936C61.9656 63.936 64.1434 61.758 64.1434 59.0719C64.1434 56.385 61.9656 54.207 59.2796 54.207C56.5929 54.207 54.415 56.385 54.415 59.0719C54.415 61.758 56.5929 63.936 59.2796 63.936Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M36.0206 44.6904L29.2878 43.0071L15 46.837L16.8287 53.65L38.0351 47.9637L32.3095 69.1713L39.1087 71L42.9519 56.6719L41.256 49.9387C40.9478 48.6681 40.2972 47.5063 39.3736 46.5803C38.4506 45.6551 37.2905 45.0008 36.0206 44.6904Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M32.3095 16.8291L37.9955 38.0364L16.7891 32.35L15 39.1235L29.2878 42.9534L36.0206 41.3365C37.2972 41.0217 38.4618 40.3598 39.3855 39.4242C40.3092 38.4885 40.9568 37.3156 41.256 36.0352L42.9519 29.3013L39.1087 15L32.3095 16.8291Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M49.9264 41.3365L56.7129 42.9534L70.9999 39.1235L69.1847 32.3105L47.9783 37.9968L53.6643 16.7894L46.8383 15L42.9951 29.3282L44.6917 36.0352C44.9962 37.3126 45.6453 38.4826 46.5682 39.4175C47.4911 40.3524 48.6528 41.0164 49.9264 41.3365Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M49.9264 44.6904C48.664 45.003 47.5105 45.6529 46.5883 46.5699C45.6661 47.4877 45.0111 48.6382 44.6917 49.8992L42.9951 56.6324L46.8383 70.9605L53.6509 69.1713L47.9649 47.9637L69.1713 53.65L70.9873 46.837L56.7129 43.0071L49.9264 44.6904Z",
                fill: "white"
            })
        ]
    }));
};



/***/ }),

/***/ 56963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ NVTTokenIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);




var NVTTokenIcon = function(_param) {
    var _width = _param.width, width = _width === void 0 ? 86 : _width, height = _param.height, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "width",
        "height"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: width,
        height: height !== null && height !== void 0 ? height : width,
        viewBox: "0 0 86 86",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "43",
                cy: "43",
                r: "41.5",
                fill: "#EA6B0E",
                stroke: "#AA3401",
                strokeWidth: "3"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M36.6564 39.0465L33.0858 33.0954L20.2747 25.7007L16.7503 31.8112L35.7662 42.7855L16.7217 53.7328L20.2363 59.8337L33.0853 52.4198L36.6472 46.4595C37.3278 45.3432 37.6892 44.0616 37.6909 42.7538C37.6925 41.4469 37.3348 40.1639 36.6564 39.0465Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M53.7329 16.7218L42.7577 35.7382L31.7835 16.7222L25.7288 20.2467L33.1236 33.0578L39.0277 36.6752C40.153 37.3553 41.4445 37.7108 42.7593 37.7024C44.074 37.6939 45.3613 37.3224 46.4782 36.6286L52.439 33.0662L59.8339 20.2362L53.7329 16.7218Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M48.8605 46.5085L52.516 52.4506L65.3265 59.8449L68.8605 53.7438L49.8446 42.7695L68.861 31.7943L65.2995 25.7023L52.4506 33.1163L48.9077 39.0585C48.2197 40.177 47.8514 41.4633 47.8429 42.777C47.8344 44.0907 48.1863 45.3816 48.8605 46.5085Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M46.4892 48.8793C45.3755 48.2077 44.1003 47.8516 42.7998 47.848C41.4988 47.8448 40.222 48.1952 39.1046 48.861L33.1439 52.4224L25.7299 65.2713L31.8123 68.8234L42.7876 49.8069L53.7619 68.8228L59.8635 65.2894L52.4782 52.4878L46.4892 48.8793Z",
                fill: "white"
            })
        ]
    }));
};



/***/ }),

/***/ 9357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ StarIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);

var StarIcon = function(param) {
    var _startColor = param.startColor, startColor = _startColor === void 0 ? "currentColor" : _startColor, _endColor = param.endColor, endColor = _endColor === void 0 ? "currentColor" : _endColor;
    var gradientId = "gradient-".concat(startColor.replace(/[^\dA-Za-z]/g, ""), "-").concat(endColor.replace(/[^\dA-Za-z]/g, ""));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                id: gradientId,
                x1: "0%",
                y1: "100%",
                x2: "100%",
                y2: "100%",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                        offset: "0%",
                        style: {
                            stopColor: startColor,
                            stopOpacity: 1
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                        offset: "100%",
                        style: {
                            stopColor: endColor,
                            stopOpacity: 1
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M16 0L17.3773 5.65779C18.4962 10.2545 22.1317 13.8149 26.7508 14.8377L32 16L26.4191 17.398C21.9781 18.5105 18.5105 21.9781 17.398 26.4191L16 32L14.602 26.4191C13.4895 21.9781 10.0219 18.5105 5.58089 17.398L0 16L5.58089 14.602C10.0219 13.4895 13.4895 10.0219 14.602 5.58089L16 0Z",
                fill: "url(#".concat(gradientId, ")")
            })
        ]
    });
};


/***/ }),

/***/ 89320:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fee-section":"FeeComparison_fee-section__yODPl","fee-comparison":"FeeComparison_fee-comparison__4Bdsq","logo-cell":"FeeComparison_logo-cell__BH_5_","full-row-col":"FeeComparison_full-row-col__nSGAX","fake-second-header":"FeeComparison_fake-second-header__SBm5W","fee-footnote":"FeeComparison_fee-footnote__qC0ow","slide":"FeeComparison_slide__TA9Hf","dash":"FeeComparison_dash__HPTJI","spin":"FeeComparison_spin__on_y5","rotate":"FeeComparison_rotate__pH_q1","floating":"FeeComparison_floating__SzgDK"};

/***/ }),

/***/ 16962:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card-table":"CardTable_card-table__u7RX_","card-table-header":"CardTable_card-table-header__AiiU1","card-table-column":"CardTable_card-table-column__lkwX9","center":"CardTable_center__JREo_","card-table-row":"CardTable_card-table-row__UVtds","bold":"CardTable_bold__hxBli","slide":"CardTable_slide__kiOUb","dash":"CardTable_dash__PAmP3","spin":"CardTable_spin__hGjxu","rotate":"CardTable_rotate__nu7cf","floating":"CardTable_floating__hLQHD"};

/***/ }),

/***/ 50134:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"portfolio-allocations":"PortfolioAllocations_portfolio-allocations__mx6Zh","title":"PortfolioAllocations_title__nflfj","subtitle":"PortfolioAllocations_subtitle__adaE3","card":"PortfolioAllocations_card__ukKBC","description":"PortfolioAllocations_description__tU_0m","deposit-cap":"PortfolioAllocations_deposit-cap__BGaOp","footer-text":"PortfolioAllocations_footer-text__hYt8Q","slide":"PortfolioAllocations_slide__Zem1q","dash":"PortfolioAllocations_dash__LYJXL","spin":"PortfolioAllocations_spin__dv9_N","rotate":"PortfolioAllocations_rotate__DZbGs","floating":"PortfolioAllocations_floating__1CAol"};

/***/ }),

/***/ 85849:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"double-feature":"DoubleFeature_double-feature__lg1l9","slide":"DoubleFeature_slide__7LiI6","dash":"DoubleFeature_dash__Fe1sr","spin":"DoubleFeature_spin__uk128","rotate":"DoubleFeature_rotate__zSzvY","floating":"DoubleFeature_floating__aRgJh"};

/***/ }),

/***/ 28405:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image-button-row":"ImageButtonRow_image-button-row__pLIpz","image-button":"ImageButtonRow_image-button__PmKJN","slide":"ImageButtonRow_slide__LkM6v","dash":"ImageButtonRow_dash__gfjCU","spin":"ImageButtonRow_spin__P9O4Y","rotate":"ImageButtonRow_rotate__lqfkg","floating":"ImageButtonRow_floating__Sljyb"};

/***/ }),

/***/ 73314:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"media-carousel":"MediaCarousel_media-carousel__KqPYx","media-card":"MediaCarousel_media-card__HA87Y","spin":"MediaCarousel_spin__stzby","media-source":"MediaCarousel_media-source__2hdPY","source-text":"MediaCarousel_source-text___aRQ9","media-title":"MediaCarousel_media-title__YJ6Rd","media-date":"MediaCarousel_media-date__0iIDS","slide":"MediaCarousel_slide__qcXF2","dash":"MediaCarousel_dash__2lSjm","rotate":"MediaCarousel_rotate__TtR36","floating":"MediaCarousel_floating__nkc8T"};

/***/ }),

/***/ 66404:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"callout-container":"NDAOTokenCallout_callout-container__tFF_s","callout-inner":"NDAOTokenCallout_callout-inner__qrVhf","ndao-callout":"NDAOTokenCallout_ndao-callout__WFHjQ","rotate":"NDAOTokenCallout_rotate__Z6Ylo","learn-more-button":"NDAOTokenCallout_learn-more-button__myuul","slide":"NDAOTokenCallout_slide__CnuN5","dash":"NDAOTokenCallout_dash__TqIFA","spin":"NDAOTokenCallout_spin__9OTFO","floating":"NDAOTokenCallout_floating___agGm"};

/***/ }),

/***/ 78091:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"two-screens-section":"TwoScreensSection_two-screens-section__Uu4oR","screenshot":"TwoScreensSection_screenshot__pSfTy","slide":"TwoScreensSection_slide__rNqkt","dash":"TwoScreensSection_dash__DutK5","spin":"TwoScreensSection_spin__NgPj4","rotate":"TwoScreensSection_rotate__OrUWQ","floating":"TwoScreensSection_floating__I1VDh"};

/***/ }),

/***/ 49158:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"donor-hero":"donors_donor-hero__ZotrG","stats-container":"donors_stats-container__wBWJx","learn-more-container":"donors_learn-more-container__6fc0B","slide":"donors_slide__sayQC","dash":"donors_dash__2boqu","spin":"donors_spin__6dsGU","rotate":"donors_rotate__rxLdY","floating":"donors_floating__hstp1"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [652,602,577,282,253,389,59,774,888,179], function() { return __webpack_exec__(21181); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);